import React from 'react';
import classNames from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Container } from '../../../../symphony';

import { SlLEContext } from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { CommentsIcon } from './CommentsIcon';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

import s from './LessonHeader.scss';

export function LessonHeaderComments(): JSX.Element {
	useStyles(s);
	const { lpComments$: comments } = useContainerData(
		SlLEContext,
		SlDataService,
		['lpComments$'],
	);

	const { actions$ } = Container.take(SlLEContext, SlActions);

	const handleCommentsClick = (e) => {
		if (comments.disabled) {
			e.preventDefault();
		}
		actions$.next({
			type: ActionType.OnLPCommentsClick,
			requestType: RequestType.Parallel,
		});
	};

	return comments && !comments.hide ? (
		<div
			sl-test-data="cmpLessonHeaderComments"
			className={classNames('le-lesson-header__comments', {
				locked: comments.disabled,
			})}
			onClick={handleCommentsClick}
		>
			<CommentsIcon />
			<span>{comments.count}</span>
		</div>
	) : null;
}
